import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import MainNav from "./MainNav";

@inject("NavListStore")
@observer
class NavContainer extends Component {
  get mainNavData() {
    const navData = this.props.NavListStore;
    const { navListData } = navData;
    const { data } = navListData;
    const { menu: { level1 } } = data || { menu: {} };

    if (level1) {
      return level1.slice(0, 7);
    }

    return null;
  }

  render() {
    if (!this.mainNavData) return null;

    return (
      <nav className="nw-navcontainer">
        <ul className="nw-navcontainer-list">
          {this.mainNavData.map(topMenu => (
            <MainNav.component key={topMenu.name} menu={topMenu} />
          )) || null}
        </ul>
      </nav>
    );
  }
}

NavContainer.wrappedComponent.propTypes = {
  NavListStore: PropTypes.shape({
    navListData: PropTypes.object,
    getNavListData: PropTypes.func,
  }).isRequired,
};

export { default as MainNav } from "./MainNav";

const getFinalComponent = component =>
  inject("NavListStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: NavContainer.wrappedComponent,
  component: NavContainer,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Header/DesktopHeader/NavContainer/index.js